// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171104/js/" + chunkId + "." + {"44":"94d37555","225":"5b63322e","481":"32179ba4","486":"8483591e","770":"e12d14a2"}[chunkId] + ".0.8293404635879559.chunk.js";
};